import { createSlice } from '@reduxjs/toolkit'
import Api from "services/api"

export const initialState = {
    payroll: null,
    loader: false,
    error: {},
}

export const payrollSlice = createSlice({
    name: 'payroll',
    initialState,
    reducers: {
        setPayroll: (state, { payload }) => {
            state.payroll = payload
        },
        setError: (state, { payload }) => {
            state.error = payload
        },
        setLoader: (state, { payload }) => {
            state.loader = payload
        },
    }
})

export const { setPayroll, setError, setLoader } = payrollSlice.actions

export const payrollSelector = state => state.payroll

export default payrollSlice.reducer

export const downloadPayroll = (params = {}, callback) => async (dispatch) => {
    try {
        const json = await Api.downloadPayroll(params)
        if (json.status >= 200 && json.status < 300) {
            callback && callback(true, json.data) // json.data is the xlsx Blob
        } else {
            // Error responses arrive as a JSON blob because responseType is 'blob'
            let message = 'Something went wrong'
            try {
                const text = await json.data.text()
                message = JSON.parse(text)?.message || message
            } catch (e) { /* keep fallback message */ }
            callback && callback(false, message)
        }
    } catch (error) {
        console.log(error)
        callback && callback(false, 'Server error')
    }
}

export const fetchPayroll = (params = {}, callback) => async (dispatch) => {
    dispatch(setError({}))
    dispatch(setLoader(true))
    try {
        const json = await Api.fetchPayroll(params)
        if (json.status >= 200 && json.status < 300) {
            dispatch(setPayroll(json.data.data))
            callback && callback(true, json.data.message)
        } else if (json.status == 422) {
            dispatch(setError(json.data))
            callback && callback(false, json.data.message)
        } else {
            dispatch(setError(json?.data || {}))
            callback && callback(false, json?.data?.message || 'Something went wrong')
        }
    } catch (error) {
        console.log(error)
        callback && callback(false, 'Server error')
    }
    dispatch(setLoader(false))
}
